// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/thumbnailFileUploadService', () => import('js/thumbnailFileUploadService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid"
            ]
        }
    },
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "description": {
            "displayName": "{{i18n.description}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": " ",
            "dispValue": " ",
            "numberOfLines": 3
        },
        "image": {
            "displayName": "{{i18n.image}}",
            "type": "STRING"
        },
        "isThumbnailSelected": false
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "loadLibraryList": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "loadLibraryList"
                    }
                ]
            }
        },
        "createLibrary": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "mutation CreateLibrary( $createLibraryInput: CreateLibraryInput) { createLibrary( createLibraryInput: $createLibraryInput ) }",
                        "variables": {
                            "createLibraryInput": {
                                "name": "{{data.name.dbValue}}",
                                "description": "{{data.description.dbValue}}",
                                "tags": {
                                    "key": "library",
                                    "value": "1"
                                },
                                "createThumbnail": "{{data.isThumbnailSelected}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "createdLibrary": "data.data.createLibrary",
                "accUrl": "data.data.createLibrary.url",
                "output": "data.data.createLibrary.output"
            },
            "events": {
                "failure": [
                    {
                        "name": "desCreateLibraryFailure",
                        "eventData": {
                            "eventData": "{{createdLibrary}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desCreateLibrarySuccess",
                        "eventData": {
                            "eventData": "{{createdLibrary}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesCreateLibrarySuccessMsg",
                        "condition": "output.success === true"
                    },
                    {
                        "message": "displayDesCreateLibraryFailureMsg",
                        "condition": "output.success === false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateSelectedFileInfoAction": {
            "actionType": "JSFunction",
            "method": "getSelectedFileInfo",
            "inputData": {
                "fileName": "{{parameters.fileName}}",
                "formData": "{{parameters.formData}}",
                "parameters": "{{parameters}}"
            },
            "outputData": {
                "fileInputForms": "fileInputForms",
                "fileNames": "fileNames",
                "isFileValid": "isFileValid",
                "fileType": "fileType"
            },
            "events": {
                "success": [
                    {
                        "name": "fileSelectionSuccess",
                        "eventData": {
                            "eventData": "{{isFileValid}}"
                        }
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "uploadFileToServer": {
            "actionType": "JSFunctionAsync",
            "method": "sendDssFileToUpload",
            "inputData": {
                "accsessionid": "{{props.accsessionid}}",
                "thumbnailTicket": "{{data.createdLibrary.output.data.thumbnailUploadTicket}}",
                "formData": "{{data.fileInputForms}}",
                "fileType": "{{data.fileType}}",
                "accUrl": "{{data.accUrl}}"
            },
            "events": {
                "success": [
                    {
                        "name": "uploadfilesuccess"
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "selectThumbnail": {
            "actionType": "JSFunction",
            "method": "updateThumbnailBool",
            "inputData": {
                "vmo": "{{data}}",
                "validFile": "{{parameters.eventData}}"
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "performBatchActionOnCreateLibrary": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "uploadFileToServer",
                    "condition": "data.isThumbnailSelected === true"
                },
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "loadLibraryList"
                }
            ]
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "onEvent": [
        {
            "eventId": "desCreateLibrarySuccess",
            "action": "performBatchActionOnCreateLibrary",
            "inputArgs": {
                "eventName": "desCreateLibrarySuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desCreateLibraryFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desCreateLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "invalidFileSelected",
            "message": "invalidFileError"
        },
        {
            "eventId": "fileSelectionSuccess",
            "action": "selectThumbnail",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "messages": {
        "displayDesCreateLibrarySuccessMsg": {
            "messageType": "INFO",
            "messageText": "\"{0}\" created successfully",
            "messageTextParams": [
                "{{data.name.dbValue}}"
            ]
        },
        "displayDesCreateLibraryFailureMsg": {
            "messageType": "ERROR",
            "messageText": "{{i18n.createLibraryFailedMsg}}"
        },
        "invalidFileError": {
            "messageType": "WARNING",
            "messageText": "{{i18n.invalidFileError}}",
            "navigationOptions": [
                {
                    "option": "Cancel",
                    "text": "{{i18n.CancelText}}"
                }
            ]
        }
    },
    "conditions": {
        "enableCreateButton": {
            "expression": "data.name.dbValue"
        }
    },
    "i18n": {
        "buttonDemo": [
            "DesLibraryMessages"
        ],
        "name": [
            "DesLibraryMessages"
        ],
        "description": [
            "DesLibraryMessages"
        ],
        "key": [
            "DesLibraryMessages"
        ],
        "value": [
            "DesLibraryMessages"
        ],
        "image": [
            "DesLibraryMessages"
        ],
        "add": [
            "Add"
        ],
        "tags": [
            "DesLibraryMessages"
        ],
        "createButton": [
            "DesLibraryMessages"
        ],
        "createLibrarySuccessMsg": [
            "DesLibraryMessages"
        ],
        "libraryNameAlreadyExists": [
            "DesLibraryMessages"
        ],
        "upload": [
            "DesLibraryMessages"
        ],
        "invalidFileError": [
            "DesLibraryMessages"
        ],
        "CancelText": [
            "DesLibraryMessages"
        ],
        "fileUploadSuccess": [
            "DesLibraryMessages"
        ],
        "nameError": [
            "DesLibraryMessages"
        ],
        "createLibraryFailedMsg": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesCreateLibrary",
    "_uniqueViewModelId": "DesCreateLibrary",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-textbox prop="data.name"></aw-textbox>
        <aw-break></aw-break>
        <aw-textarea prop="data.description"></aw-textarea>
        <aw-break></aw-break>
        <aw-label prop="data.image"></aw-label>
        <aw-file-upload type-filter=".png, .gif, .jpg, .jpeg" file-change-action="updateSelectedFileInfoAction">
        </aw-file-upload>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button class='small' button-type='accent-high-contrast' size='stretched' action='createLibrary'
            enable-when="conditions.enableCreateButton">{{i18n.createButton}}
        </aw-button>
        <aw-break></aw-break>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwTextbox {...getField("data.name", fields, $index, null, null )}>
            </AwTextbox>
            <AwBreak>
            </AwBreak>
            <AwTextarea {...getField("data.description", fields, $index, null, null )}>
            </AwTextarea>
            <AwBreak>
            </AwBreak>
            <AwLabel {...getField("data.image", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} typeFilter=".png, .gif, .jpg, .jpeg" fileChangeAction={actions.updateSelectedFileInfoAction}>
            </AwFileUpload>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen className="small" buttonType="accent-high-contrast" size="stretched" action={actions.createLibrary} enableWhen={AwParseService.instance( "conditions.enableCreateButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.createButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
            <AwBreak>
            </AwBreak>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;